import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableGrid = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9.60001H18",
			stroke: "#281E38",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 13.8H18",
			stroke: "#281E38",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.6001 6V18",
			stroke: "#281E38",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8 18H7.2C6.88174 18 6.57652 17.8736 6.35147 17.6485C6.12643 17.4235 6 17.1183 6 16.8V7.2C6 6.88174 6.12643 6.57652 6.35147 6.35147C6.57652 6.12643 6.88174 6 7.2 6H16.8C17.1183 6 17.4235 6.12643 17.6485 6.35147C17.8736 6.57652 18 6.88174 18 7.2V16.8C18 17.1183 17.8736 17.4235 17.6485 17.6485C17.4235 17.8736 17.1183 18 16.8 18Z",
			stroke: "#281E38",
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgTableGrid);
export default ForwardRef;
